import { render } from "./EditOrg.vue?vue&type=template&id=d837cc26&scoped=true"
import script from "./EditOrg.vue?vue&type=script&lang=js"
export * from "./EditOrg.vue?vue&type=script&lang=js"

import "./EditOrg.vue?vue&type=style&index=0&id=d837cc26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d837cc26"]])

export default __exports__